// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmNewZipForm_container__1AZDu","zipLabel":"ConfirmNewZipForm_zipLabel__3A3dr","zipInput":"ConfirmNewZipForm_zipInput__2Cy_U"};